"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultClientConfig = void 0;
var core_js_1 = require("@web3api/core-js");
var ipfs_plugin_js_1 = require("@web3api/ipfs-plugin-js");
var ethereum_plugin_js_1 = require("@web3api/ethereum-plugin-js");
var ens_plugin_js_1 = require("@web3api/ens-plugin-js");
var graph_node_plugin_js_1 = require("@web3api/graph-node-plugin-js");
var http_plugin_js_1 = require("@web3api/http-plugin-js");
var fs_plugin_js_1 = require("@web3api/fs-plugin-js");
var uts46_plugin_js_1 = require("@web3api/uts46-plugin-js");
var sha3_plugin_js_1 = require("@web3api/sha3-plugin-js");
var logger_plugin_js_1 = require("@web3api/logger-plugin-js");
var tracing_js_1 = require("@web3api/tracing-js");
exports.getDefaultClientConfig = tracing_js_1.Tracer.traceFunc("client-js: getDefaultClientConfig", function () {
    return {
        envs: [],
        redirects: [],
        plugins: [
            // IPFS is required for downloading Web3API packages
            {
                uri: new core_js_1.Uri("w3://ens/ipfs.web3api.eth"),
                plugin: ipfs_plugin_js_1.ipfsPlugin({
                    provider: "https://ipfs.fleek.co",
                    fallbackProviders: ["https://ipfs.io", "https://ipfs.infura.io"],
                }),
            },
            // ENS is required for resolving domain to IPFS hashes
            {
                uri: new core_js_1.Uri("w3://ens/ens.web3api.eth"),
                plugin: ens_plugin_js_1.ensPlugin({}),
            },
            {
                uri: new core_js_1.Uri("w3://ens/ethereum.web3api.eth"),
                plugin: ethereum_plugin_js_1.ethereumPlugin({
                    networks: {
                        mainnet: {
                            provider: "https://mainnet.infura.io/v3/b00b2c2cc09c487685e9fb061256d6a6",
                        },
                    },
                }),
            },
            {
                uri: new core_js_1.Uri("w3://ens/http.web3api.eth"),
                plugin: http_plugin_js_1.httpPlugin(),
            },
            {
                uri: new core_js_1.Uri("w3://ens/js-logger.web3api.eth"),
                plugin: logger_plugin_js_1.loggerPlugin(),
            },
            {
                uri: new core_js_1.Uri("w3://ens/uts46.web3api.eth"),
                plugin: uts46_plugin_js_1.uts46Plugin(),
            },
            {
                uri: new core_js_1.Uri("w3://ens/sha3.web3api.eth"),
                plugin: sha3_plugin_js_1.sha3Plugin(),
            },
            {
                uri: new core_js_1.Uri("w3://ens/graph-node.web3api.eth"),
                plugin: graph_node_plugin_js_1.graphNodePlugin({
                    provider: "https://api.thegraph.com",
                }),
            },
            {
                uri: new core_js_1.Uri("w3://ens/fs.web3api.eth"),
                plugin: fs_plugin_js_1.filesystemPlugin(),
            },
        ],
        interfaces: [
            {
                interface: core_js_1.coreInterfaceUris.uriResolver,
                implementations: [
                    new core_js_1.Uri("w3://ens/ipfs.web3api.eth"),
                    new core_js_1.Uri("w3://ens/ens.web3api.eth"),
                    new core_js_1.Uri("w3://ens/fs.web3api.eth"),
                ],
            },
            {
                interface: core_js_1.coreInterfaceUris.logger,
                implementations: [new core_js_1.Uri("w3://ens/js-logger.web3api.eth")],
            },
        ],
    };
});
//# sourceMappingURL=default-client-config.js.map